import type { Store } from 'effector'
import type { UiTvBundleInfo } from './index.h'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { formatBundleWithContent, formatTvBundleRowWithContent } from './lib'

export const $tvBundleWithContentPageInfo =
  api.tvBundles.$tvBundleWithContentPageInfo

export const $tvBundleWithContentFormatted = combine(
  i18n.$t,
  ssePurchasesModel.$channel,
  ssePurchasesModel.$channelSet,
  api.tvBundles.$tvBundleWithContent,
  ({ t }, adjustChannel, adjustSet, content) =>
    content
      ? formatBundleWithContent(content, adjustChannel, adjustSet, t)
      : null
)

export const $tvBundlesRowFormatted: Store<UiTvBundleInfo[]> = combine(
  api.tvBundles.$tvBundlesRow,
  ssePurchasesModel.$channelSet,
  i18n.$t,
  (content, adjust, { t }) =>
    content.map(formatTvBundleRowWithContent(t, adjust))
)

export const $tvBundlesRowTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('extras')
)
